import { OrderConfigResponse, DiscountType } from '@ca/common'
import { OrderItem } from '@order/orderTypes'
import { useCallback } from 'react'

interface GetDiscountOrdersParams {
  selectOrders?: boolean
  selectedOrders?: string[]
  result: OrderConfigResponse
  mode: DiscountType
}

export const useGetDiscountOrders = (items: OrderItem[]) => {
  const getOrders = useCallback(
    ({
      result,
      mode,
      selectedOrders,
      selectOrders,
    }: GetDiscountOrdersParams) => {
      const sorted = items
        .map((item) => result?.orders.find((o) => o.data.localId === item.id))
        .filter((v) => !!v)

      if (selectOrders && selectedOrders) {
        return sorted.filter((o) => selectedOrders.includes(o.id.toString()))
      }

      if (mode === 'coupon' || mode === 'referral') {
        return [sorted[0]]
      }
      return sorted
    },
    [items]
  )

  return getOrders
}
